import { Directive } from '@angular/core';

@Directive({
  selector: '[pxwCardHeader]',
  standalone: true,
})
export class CardHeaderDirective {}
